import { render, staticRenderFns } from "./TitanBackButton.vue?vue&type=template&id=665bb825&scoped=true"
import script from "./TitanBackButton.vue?vue&type=script&lang=js"
export * from "./TitanBackButton.vue?vue&type=script&lang=js"
import style0 from "./TitanBackButton.vue?vue&type=style&index=0&id=665bb825&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665bb825",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/workspace/Control-Panel/Control-Panel-Preprod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('665bb825')) {
      api.createRecord('665bb825', component.options)
    } else {
      api.reload('665bb825', component.options)
    }
    module.hot.accept("./TitanBackButton.vue?vue&type=template&id=665bb825&scoped=true", function () {
      api.rerender('665bb825', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/core/TitanBackButton.vue"
export default component.exports